import {
  FormField,
  Input,
} from '@cloudscape-design/components';
import { PropTypes } from 'prop-types';
import React, {
  useEffect,
  useState,
} from 'react';

function PLCNumberInput({
  label,
  description = '',
  disabled = false,
  errorText = '',
  max = undefined,
  min = undefined,
  type = 'float',
  value,
  onUpdate,
}) {
  const [currentValue, setCurrentValue] = useState(
    value === undefined || value === null ? '' : String(value),
  );

  useEffect(() => {
    setCurrentValue(value === undefined || value === null ? '' : String(value));
  }, [value]);

  const hasUnsavedChanges = currentValue !== (value === undefined || value === null ? '' : String(value));
  const savedValueLabel = value === undefined || value === null ? '--' : value;
  const currentNumber = type === 'int'
    ? Number.parseInt(currentValue, 10)
    : Number.parseFloat(currentValue);
  const currentError = currentValue !== '' && (
    Number.isNaN(currentNumber)
      || (min !== undefined && currentNumber < min)
      || (max !== undefined && currentNumber > max)
  )
    ? `Value must be between ${min ?? 'no minimum'} and ${max ?? 'no maximum'}`
    : '';
  const helperText = hasUnsavedChanges
    ? `Unsaved changes (click away to save). Current value: ${savedValueLabel}`
    : null;

  const handleBlur = () => {
    if (!hasUnsavedChanges || currentValue === '') {
      return;
    }

    const nextValue = type === 'int'
      ? Number.parseInt(currentValue, 10)
      : Number.parseFloat(currentValue);

    if (Number.isNaN(nextValue)
      || (min !== undefined && nextValue < min)
      || (max !== undefined && nextValue > max)) {
      return;
    }

    onUpdate(nextValue);
  };

  return (
    <FormField
      label={label}
      description={description}
      errorText={currentError || errorText || helperText}
      stretch
    >
      <Input
        max={max}
        min={min}
        step={1}
        inputMode="numeric"
        type="number"
        value={currentValue}
        disabled={disabled}
        onChange={({ detail }) => { setCurrentValue(detail.value); }}
        onBlur={handleBlur}
      />
    </FormField>
  );
}

PLCNumberInput.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onUpdate: PropTypes.func.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool,
  errorText: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number,
  type: PropTypes.oneOf(['int', 'float']),
};

export default PLCNumberInput;
